/*eslint-disable*/
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { usePostHog } from 'posthog-js/react'
import styled from '@emotion/styled';

import {
    Alert,
    Button,
} from 'reactstrap';

const BillingWarningWrapper = styled.div`
    text-align: left;
    //display: ${props => props.compactVersion ? 'flex' : 'block'};

    .billing-warning-alert {
        &.compact-version {
            margin-top: 10px;
            padding: 8px;

            .alert-heading {
                font-size: 14px;
            }

            p {
                font-size: 12px;
                margin-bottom: 2px;
            }
            .upgrade-cta {
                font-size: 12px;
                color: #0E121B;
                font-weight: 500;
            }
            .learn-more-link {
                font-size: 12px;
                color: #0E121B;
                font-weight: 500;
                margin-left: 10px;
            }
        }
    }
    
`;

const BillingWarning = ({
    heading,
    bodyText,
    userInfo,
    compactVersion = false,
    learnMoreLink = '',
}) => {
    const navigate = useNavigate();
    const posthog = usePostHog();

    const navigateBilling = () => {
        navigate('/admin/settings/billing');
        posthog.capture('upgrade_button_clicked', {
            'user_name': userInfo?.name,
        });
    };

    return (
        <BillingWarningWrapper compactVersion={compactVersion}>
            <Alert color='warning' className={`billing-warning-alert ${compactVersion ? 'compact-version' : ''}`}>
                <h6 className="alert-heading">{heading}</h6>
                <p style={{ fontSize: '14px' }}>{bodyText}</p>
                {
                    compactVersion && (
                        <>
                            <a
                                className="upgrade-cta"
                                href="/admin/settings/billing"
                                rel="noreferrer"
                            >
                                Upgrade
                            </a>
                            <a rel="noreferrer" target="_blank" className="learn-more-link" href={learnMoreLink}>Learn more</a>
                        </>

                    )
                }


            </Alert>
            {
                !compactVersion && <Button color="primary" onClick={navigateBilling}>Upgrade</Button>
            }
        </BillingWarningWrapper>
    );
};

export default BillingWarning;
